const MainMenu = (($) => {
  let _els = {};

  const init = () => {
    _els.navbar = $('.navbar');
    _els.hamburger = $('.navbar .hamburger');
    _addListeners();
  };

  const _addListeners = () => {
    var mainMenu = document.getElementById('mainMenu');

    mainMenu.addEventListener('show.bs.collapse', function() {
      console.log ( 'show.bs.collapse' );
      _els.hamburger.addClass('is-active');
      // _els.navbar.addClass('open');
    });

    mainMenu.addEventListener('hide.bs.collapse', function() {
      console.log ( 'hide.bs.collapse' );
      _els.hamburger.removeClass('is-active');
      // _els.navbar.removeClass('open');
    });
  };

  module.exports = {
    init: init,
  };
})(jQuery);
